<template>
  <section class="section-9 wrapper">
    <div class="hd">
      <h2 class="title">
        预约体验TTPS
      </h2>
    </div>

    <div class="pic">
      TTPS
    </div>
    <a
      class="btn btn-coupon"
      href="https://school.jin10.com/course/98"
      target="_blank"
    >
      <span>领100元抵1000元折扣券</span>
    </a>
    <btn-contact
      class="btn-contact"
      name="B页-预约体验TTPS-预约咨询"
    />
  </section>
</template>

<script>
import BtnContact from './BtnContact.vue';

export default {
  components: {
    BtnContact,
  },
  data() {
    return {
      list: [],
      current: 0,
      pageSize: 4,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.section-9 {
  padding-top: percentage(132px / $deviceWidth);
  padding-bottom: percentage(120px / $deviceWidth);

  &.active {
    .pic {
      animation: flipInY 1.2s both;
    }
    .btn-coupon {
      &::after {
        animation: fadeInUp .4s 1s both;
      }
    }
  }

  .title {
    width: percentage(560px / $deviceWidth);
    padding-top: percentage(140px / $deviceWidth);
  }

  .pic {
    opacity: 0;
    width: percentage(1024px / $deviceWidth);
    margin: 0 auto percentage(86px / $deviceWidth);
    padding-top: percentage(534px / $deviceWidth);
    background: url("~assets/ttps-book.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/ttps-book@2x.png");
    }
  }

  .btn {
    display: inline-block;
    margin-right: percentage(60px / $deviceWidth);
    border: 0;
    padding: 0;
    font-size: 0;
    background-color: transparent;
    width: percentage(452px / $deviceWidth);
    padding-top: percentage(78px / $deviceWidth);
    background: url("~assets/btn-coupon.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/btn-coupon@2x.png");
    }

    &.btn-coupon {
      position: relative;
      background-color: #305EE0;
      color: #fff;
      font-weight: bold;
      text-decoration: none;
      span {
        display: none;
        font-size: 0;
        line-height: 0;
      }

      &::after {
        content: "";
        opacity: 0;
        position: absolute;
        top: percentage(-24px / 78px);
        right: percentage(-47px / 452px);
        width: percentage(141px / 452px);
        padding-top: percentage(54px / 452px);
        background: url("~assets/btn-tip.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/btn-tip@2x.png");
        }
      }
    }
  }

  @include mediaWidth(1440px) {
    .btn {
      &.btn-coupon {
        font-size: 20px;
      }
    }
  }

  @include mediaWidth(1024px) {
    .btn {
      &.btn-coupon {
        // font-size: 14px;
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding: percentage(64px / $mbWidth) 0;
    .title {
      width: percentage(346px / $mbWidth);
      padding-top: percentage(86px / $mbWidth);
    }
    .pic {
      width: percentage(596px / $mbWidth);
      margin: 4px auto percentage(42px / $mbWidth);
      padding-top: percentage(310px / $mbWidth);
      background: url("~assets/ttps-book-m.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/ttps-book-m@2x.png");
      }
    }
    .btn {
      &.btn-coupon {
        // font-size: 12px;
        background: url("~assets/btn-coupon-m.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/btn-coupon-m@2x.png");
        }
      }
    }
    .btn, .btn-contact {
      width: percentage(328px / $mbWidth);
      padding-top: percentage(67px / $mbWidth);
    }
    .btn-contact {
      background: url("~assets/btn-contact-s.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/btn-contact-s@2x.png");
      }
    }
  }
}
</style>
